import { FaDownload, FaEllipsisH, FaFilter, FaSignOutAlt, FaStore, FaUpload, FaUser } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './BonComptoireList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaEdit, FaFilePdf, FaPlus, FaSearch, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import { formatPrice, formatSigned } from '../../helpers/utility';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { POS_PAGE } from '../../routes/routeConstants';
import { productActions } from '../../sagas/productSlice';
import { authActions } from '../../sagas/authSlice';

const BonComptoireList = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const { businessName, fullName, email, address, telephone } = useSelector(state => state.auth);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(productActions.findAllUnites());
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.listComptoire(payload));
    }, [filters]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const handleLogout = () => {
        Swal.fire({
            title: t('auth.logoutConfirmTitle'),
            text: t('auth.logoutConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(authActions.logout());
                Swal.fire({
                    icon: 'success',
                    title: t('auth.logoutSuccess'),
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    navigate('/login');
                });
            }
        });
    };


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    icon: 'error',
                    title: t('product.invalidFileType'),
                    text: t('product.excelOnly'),
                });
                return;
            }

            try {
                const formData = new FormData();
                formData.append('file', file);

                let payload = {
                    formData: formData,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: t('delivery.uploadSuccess'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#198754'
                        });
                        refrechBLs();
                    },
                }
                dispatch(deliveryActions.uploadBLs(payload));

            } catch (error) {
                console.error('Error parsing Excel:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: "Erreur lors de l'importation des produits",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.listComptoire(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    const handleGeneratePdf = async (receiptData) => {
        try {
              const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 300],
              });
        
              const pageWidth = 80;
              const margin = 4;
              let y = 6;
        
              // === HEADER ===
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(14);
              doc.text(businessName || 'MATJARPOS', pageWidth / 2, y, { align: 'center' });
              y += 5;
        
              doc.setFontSize(8);
              doc.setFont('helvetica', 'normal');
              if (address) {
                const lines = doc.splitTextToSize(address, pageWidth - margin * 2);
                lines.forEach((line, i) => doc.text(line, pageWidth / 2, y + i * 3, { align: 'center' }));
                y += lines.length * 3;
              }
              if (telephone || email) {
                if (telephone) doc.text(` ${telephone}`, pageWidth / 2, y + 4, { align: 'center' });
                if (email) doc.text(`${email}`, pageWidth / 2, y + 8, { align: 'center' });
                y += email ? 10 : 6;
              }
        
              // Fine separator
              doc.setLineWidth(0.3);
              doc.line(margin, y, pageWidth - margin, y);
              y += 5;
        
              // === RECEIPT INFO ===
              doc.setFontSize(9);
              doc.setFont('helvetica', 'bold');
              doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
              y += 6;
        
              doc.setFontSize(7);
              doc.setFont('helvetica', 'normal');
              doc.text(`N°: ${receiptData?.numero || '---'}`, margin, y);
              doc.text(`Date: ${receiptData?.dateOperation || '---'}`, pageWidth - margin, y, { align: 'right' });
              y += 4;
              doc.text(`Caissier: ${receiptData?.createdBy || '---'}`, margin, y);
              y += 4;
        
              // === CLIENT ===
              if (receiptData?.clientNom) {
                const clientText = doc.splitTextToSize(receiptData.clientNom, pageWidth - 30);
                doc.text('Client:', margin, y);
                clientText.forEach((t, i) => doc.text(t, margin + 15, y + i * 3));
                y += clientText.length * 3 + 2;
              } else {
                doc.text('Client: Passager', margin, y);
                y += 4;
              }
        
              
        
              doc.setLineWidth(0.2);
              doc.line(margin, y, pageWidth - margin, y);
              y += 4;
        
              // === ITEMS TABLE ===
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(7);
              doc.text('Article', margin, y);
              doc.text('Qté', pageWidth - 33, y);
              doc.text('PU', pageWidth - 22, y);
              doc.text('Total', pageWidth - margin, y, { align: 'right' });
              y += 3;
              doc.setLineWidth(0.1);
              doc.line(margin, y, pageWidth - margin, y);
              y += 3;
        
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(7);
              let subtotal = 0;
        
              receiptData?.lignes?.forEach((item, i) => {
                if (y > 250) {
                  doc.addPage([80, 300]);
                  y = 6;
                }
        
                const name = item.articleNom.length > 24 ? item.articleNom.slice(0, 24) + '…' : item.articleNom;
                doc.text(name, margin, y);
        
                const unit = unites.find(u => u.code === item.unite)?.libelle || '';
                doc.text(`${item.quantiteLivree} ${unit}`, pageWidth - 35, y);
                doc.text(formatPrice(item.prixUnitaireTTC, false), pageWidth - 23, y);
                doc.text(formatPrice(item.montantTTC, false), pageWidth - margin, y, { align: 'right' });
                subtotal += parseFloat(item.montantTTC);
                y += 6;
        
                // if (i < receiptData.lignes.length - 1) {
                //   doc.setLineWidth(0.05);
                //   doc.line(margin + 5, y, pageWidth - margin - 5, y);
                //   y += 4;
                // }
              });
        
              y += 2;
              doc.setLineWidth(0.3);
              doc.line(margin, y, pageWidth - margin, y);
              y += 4;
        
              // === TOTALS ==
        
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(10);
              doc.text('TOTAL:', margin, y);
              doc.text(formatPrice(receiptData?.montantTotalTTC || subtotal, false), pageWidth - margin, y, { align: 'right' });
              y += 6;
        
              doc.setLineWidth(0.3);
              doc.line(margin, y, pageWidth - margin, y);
              y += 5;
        
              // === PAYMENT ===
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(8);
              const paymentText =
                receiptData.modeReglement === 'ESPECES' ? 'Espèces' :
                  receiptData.modeReglement === 'CARTE_BANCAIRE' ? 'Carte Bancaire' :
                    receiptData.modeReglement || '---';
              doc.text(`Paiement: ${paymentText}`, margin, y);
              y += 6;
        
              if (receiptData.montantPaye) {
                doc.text('Montant reçu:', margin, y);
                doc.text(formatPrice(receiptData.montantPaye, false), pageWidth - margin, y, { align: 'right' });
                y += 4;
        
                if (receiptData.modeReglement === 'ESPECES' &&
                  receiptData.montantPaye > receiptData?.montantTotalTTC) {
                  doc.text('Monnaie:', margin, y);
                  doc.text(formatPrice(receiptData.montantPaye - receiptData.montantTotalTTC, false), pageWidth - margin, y, { align: 'right' });
                  y += 4;
                }
              }
        
              // if (receiptData?.clientSolde !== undefined && receiptData?.clientSolde !== null) {
              //   doc.setFont('helvetica', 'bold');
              //   doc.setFontSize(12);
              //   doc.text("Solde actuel est:", margin, y);
        
              //   doc.setFont('helvetica', 'normal');
              //   doc.text(formatSigned(receiptData.clientTotalDebit, receiptData.clientTotalCredit), pageWidth - margin, y, { align: "right" });
        
              //   y += 6;
        
              //   doc.setLineWidth(0.2);
              //   doc.line(margin, y, pageWidth - margin, y);
              //   y += 5;
              // }
        
              y += 6;
              doc.setLineWidth(0.2);
              doc.line(margin, y, pageWidth - margin, y);
              y += 6;
        
              // === FOOTER ===
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(9);
              doc.text('MERCI DE VOTRE VISITE!', pageWidth / 2, y, { align: 'center' });
              y += 4;
        
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(7);
              doc.text('Gardez votre reçu pour tout échange.', pageWidth / 2, y, { align: 'center' });
              y += 3;
              doc.text('Échange possible sous 7 jours.', pageWidth / 2, y, { align: 'center' });
              y += 5;
        
              doc.setFontSize(6);
              doc.text('Powered by MatjarPOS', pageWidth / 2, y, { align: 'center' });
        
              // === EXPORT ===
              const pdfBlob = doc.output('blob');
              window.open(URL.createObjectURL(pdfBlob));
        
            } catch (err) {
              console.error('Error generating receipt:', err);
              Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Erreur lors de la génération du reçu client',
              });
            }
    };


    const handleEdit = (bl) => {
        setSelectedBonLivraison(bl);
        setShowModal(true);
    }


    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(deliveryActions.listComptoire({
                ...filters,
                query: query
            }));
        }, 1500), // Wait 1.5 seconds after user stops typing
        [filters.query]
    );


    return (
        <Container fluid>
            <div
                className="px-4 py-3 d-flex justify-content-between align-items-center shadow-sm mb-3"
                style={{
                    background: "#ffffff",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                }}
            >
                <div className="d-flex align-items-center gap-3">
                    <FaStore size={28} className="text-primary" />
                    <div>
                        <h5 className="mb-0 fw-bold text-primary">
                            {businessName || "MATJARPOS"}
                        </h5>
                        <small className="text-muted">Point de vente</small>
                    </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                    <FaUser className="text-secondary" />
                    <span className="fw-semibold">{fullName || "Utilisateur"}</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                    <Button color="primary" onClick={() => navigate(POS_PAGE)}>
                        <FaPlus className="me-2" /> {t('delivery.new')}
                    </Button>
                    {/* LOGOUT */}
                    <Button
                        color="danger"
                        className="d-flex align-items-center py-2 px-3 rounded-3"
                        onClick={handleLogout}
                    >
                        <FaSignOutAlt className="me-2" />
                        Déconnexion
                    </Button>
                </div>
            </div>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={2} md={2} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="chantierId">
                                                {t('chantier.title', 'Chantier')}:
                                            </Label>
                                            <Select
                                                id="chantierId"
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(option => option.value === filters?.chantierId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, chantierId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('chantier.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="commercialId" className="mb-1">Commercial</Label>
                                            <Select
                                                id="commercialId"
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(option => option.value === filters?.commercialId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, commercialId: selectedOption ? selectedOption.value : null }))}
                                                placeholder={t('commercial.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>                            {/* Summary Statistics Box */}


                            <table className="table table-hover table-striped table-bordered" >
                                <thead className="thead-light">
                                    <tr>

                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('delivery.chantier')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('delivery.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('delivery.commercial')}</th>
                                        <th className="align-middle text-center">{t('delivery.vendeur')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((bl) => (
                                        <tr key={bl.id}>
                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{bl.chantierNom || 'N/A'}</td>

                                            <td className="align-middle text-center">{bl.createdAt}</td>
                                            <td className="align-middle text-center">{bl.dateOperation || 'N/A'}</td>
                                            <td className="align-middle text-center">{bl.commercialNom || 'LOCAL'}</td>
                                            <td className="align-middle text-center">{bl.createdBy || 'N/A'}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estRegle}
                                                    readOnly
                                                />
                                            </td>

                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {/* Add dropdown for PDF options */}

                                                    <Button
                                                        color="danger"
                                                        title={t('common.pdf')}
                                                        onClick={() => handleGeneratePdf(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaFilePdf />
                                                    </Button>
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>


                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="11" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="8" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTaxe || 0), 0), false)}</td>
                                        <td colSpan="5"></td>
                                    </tr>
                                </tfoot>

                            </table>
                        </>)}
                </CardBody>
            </Card>
        </Container>
    );
};

export default BonComptoireList;



